module.exports = __webpack_public_path__ + "static/img/11.3b72512.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Cumplimiento-Disposiciones-Legales/11.png
// module id = JukR
// module chunks = 0